import React from 'react';
import { StarIcon } from '@avila-tek/ui/src';

interface ProductRatingProps {
  rating: number;
  reviews: number;
}

function ProductRating({ rating, reviews }: ProductRatingProps) {
  return (
    <div className="flex items-center gap-5">
      <div className="flex">
        {new Array(5).fill(5).map((star, i) => (
          <StarIcon
            key={`star-${i}`}
            className={`w-5 h-5 ${
              i < rating ? 'text-yellow-400' : 'text-gray-200 '
            } `}
          />
        ))}
      </div>
      <span className="text-neutral-cold-400">({reviews} Reviews)</span>
    </div>
  );
}

export default ProductRating;
